import { render } from "./Slides.vue?vue&type=template&id=f944b216&scoped=true"
import script from "./Slides.vue?vue&type=script&lang=js"
export * from "./Slides.vue?vue&type=script&lang=js"

import "./Slides.vue?vue&type=style&index=0&id=f944b216&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f944b216"

export default script